import MUISwitch from '@mui/material/Switch';
import MUIFormControlLabel from '@mui/material/FormControlLabel';
import InfoItem from '../InfoItem';
import ReportSetting from "../ReportSetting";

export default class ReportSettingMarketingCampaignFilter extends ReportSetting {

    /**
     * Renders MUISwitch for selecting filter mode (true/false).
     */
    renderMarketingCampaignCheckbox() {
        const handleFilterChange = (e, marketingCampaignFilter) => {
            this.handleSettingChange("marketingCampaignFilter", marketingCampaignFilter);
        }

        return (
            <MUIFormControlLabel
                control={
                    <MUISwitch
                        checked={this.state.settings.marketingCampaignFilter || false}
                        onChange={handleFilterChange}
                    />
                }
                label="Has Marketing Campaign"
            />
        );
    }

    renderContent() {
        return (
            <>
                {this.renderMarketingCampaignCheckbox()}
            </>
        );
    }

    renderReadOnly() {
        return <InfoItem label="Has Marketing Campaign" value={this.state.settings.marketingCampaignFilter ? "Yes" : "No"} />;
    }
}